import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f592e4a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dept" }, "部门列表", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deptlist" }, "当前部门下无部门", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "outellipsis" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "deptname" }
const _hoisted_11 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dept" }, "人员列表", -1))
const _hoisted_13 = { class: "search" }
const _hoisted_14 = { class: "tbspt" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("同步省平台人员")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deptlist" }, "当前部门下无人员", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 3,
  class: "body"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "tishi"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_search = _resolveComponent("van-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["title", "onClickLeft"]),
    (_ctx.deptInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.deptInfo.dept.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.deptInfo.dept, (li, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "deptstyle",
                  style: {"display":"flex","width":"95%","justify-content":"space-between"},
                  onClick: ($event: any) => (_ctx.getreqdata(li.deptId))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: require('@/assets/projectinfo-images/sheji.png'),
                      style: {"vertical-align":"middle"}
                    }, null, 8, _hoisted_9),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(li.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_van_icon, { name: "arrow" })
                  ])
                ], 8, _hoisted_7))
              }), 128)),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_van_button, {
                type: "primary",
                size: "mini",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.synchronization()))
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_van_search, {
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
              placeholder: "请输入员工姓名"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_button, {
              type: "default",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterUsername(_ctx.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          (_ctx.deptInfo.user.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deptInfo.user, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    onClick: ($event: any) => (_ctx.workerInfo(item))
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: item.photoUrl
                      }, null, 8, _hoisted_22),
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_van_icon, { name: "arrow" })
                    ])
                  ], 8, _hoisted_21))
                }), 128)),
                (_ctx.deptInfo.user.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, "没有更多了"))
                  : _createCommentVNode("", true)
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}